<template>
  <div>
    <h3>RiderLink Privacy Policy</h3>
    <div class="date-info">Last Updated: August 17, 2023</div>

    <div class="article">
      <p>
        This policy applies to your use of the RiderLink service provided by Sunmedia Technologies (Chengdu) Co., Ltd. (hereinafter referred to as "we", "us", or "Sunmedia Technologies").
        <strong>We will collect, store, use, share, disclose and protect your personal information in accordance with this policy.</strong>
        Please carefully read and understand this "RiderLink Privacy Policy" before using our products (or services), including when you
        <strong>download, install, launch, browse, or use (hereinafter collectively referred to as "use"),</strong>
        and only use the relevant products and services after confirming your full understanding and agreement.
      </p>
      <p>This policy will help you understand the following:</p>
      <ul class="title4">
        <li>1. How we collect and use your personal information</li>
        <li>2. How this privacy policy is updated</li>
        <li>3. How to contact us</li>
      </ul>
    </div>

    <div class="article">
      <h4>1. How We Collect and Use Your Personal Information</h4>
      <div class="section-title">"Content and Scope of Personal Information"</div>
      <p>
        Personal information refers to various types of information recorded electronically or by other means that can identify a specific natural person alone or in combination with other information, or reflect the activities of a specific natural person.
        The <strong>"content and scope of personal information"</strong> referred to in this policy means various information related to identified or identifiable natural persons recorded electronically or by other means,
        including names, ID numbers, communication records, text messages, communication addresses, residential addresses, account information, location tracks, etc., excluding anonymized information.
      </p>

      <div class="section-title">(1) How We Collect Your Information</div>
      <p>
        <strong><u>The information we collect during your use of our services only occurs in the following scenarios:</u></strong>
      </p>
      <p>
        1. When you use third-party SDKs integrated in this software, third parties may require you to provide corresponding personal information necessary for providing that function. Before using such functions, please be sure to carefully read the third party's "Privacy Policy". If you disagree, you can choose to stop using that function. Currently, the SDKs integrated in this software include: HERE Maps Navigation.
      </p>
      <p>
        Product Name: HERE Location SDK<br>
        Personal Information Involved: Device identifiers (Android: IMEI, MEID, IMSI, OAID; iOS: IDFV, IDFA), MAC address, IP address, location information (such as GPS, WLAN access points), device identifiers (Android: IMEI, Android ID, Serial; iOS: IDFV, IDFA), WLAN access points, installed app information<br>
        Purpose of Use: To help developers provide users with positioning and auxiliary positioning services. To provide developers with more accurate location information for end users, helping users locate their position when publishing information<br>
        Usage Scenario: Used when users use location-related functions<br>
        Partner Entity: HERE Software Limited<br>
        Collection Method: SDK collection<br>
        Partner Official Website: <a href="https://maps.here.com/"
           target="_blank">https://maps.here.com/</a><br>
        Partner Privacy Policy: <a href="https://legal.here.com/en-gb/privacy/navigation-enabled-by-here"
           target="_blank">https://legal.here.com/en-gb/privacy/navigation-enabled-by-here</a><br>
        Apart from this, we currently do not collect any other personal information related to you.
      </p>
      <p>
        2. This software obtains the following information when implementing specific functions:
      </p>
      <p>
        Obtaining device serial number to ensure the security of software services;<br>
        Obtaining mobile phone external storage permissions to store application configuration information and software operation logs;<br>
        Obtaining mobile phone MAC address to implement automatic reconnection function;<br>
        Obtaining sensor information to display altitude in the APP;<br>
        Apart from this, we currently do not collect any other personal information related to you.
      </p>

      <div class="section-title">(2) How We Use Your Information</div>
      <p>
        For information collected by third-party SDKs, please refer to the corresponding "Privacy Policy" of the third-party SDK.<br>
        This product currently does not collect your personal information, so there are no usage issues.
      </p>
    </div>

    <div class="article">
      <h4>2. How This Policy Is Updated</h4>
      <p>
        <strong>Our privacy policy may change.</strong>
      </p>
      <p>
        Without your explicit consent, we will not reduce the rights you should enjoy under this privacy policy.
      </p>
      <p>
        We will publish any changes made to this policy on this page.
      </p>
      <p>
        If you have objections to the revised privacy policy, you should promptly stop using our related services.<br>
        If you agree to the newly revised policy or continue to use our services, it means that you have fully read, understood, and agreed to our policy.
      </p>
    </div>

    <div class="article">
      <h4>3. How to Contact Us</h4>
      <p>
        If you have any questions, comments, or suggestions about this privacy policy, you can contact us through the following methods:
      </p>
      <p class="contact">
        Email: <a href="mailto:support@sunmedia.com.cn">support@sunmedia.com.cn</a><br>
        Phone: <a href="tel:028-87848688">028-87848688</a>
      </p>
      <p>
        After receiving your questions, we will process your feedback and respond to you promptly after verifying your identity.
      </p>
      <p>
        If you are not satisfied with our response, especially if our personal information processing behavior has harmed your legitimate rights and interests, you can also seek solutions through the following external channels:
      </p>
      <p class="contact">
        China: Central Cyberspace Affairs Commission Office, Cyberspace Administration of China<br>
        <a href="http://www.cac.gov.cn"
           target="_blank">http://www.cac.gov.cn</a>
      </p>
      <p class="contact">
        For contact information of personal information regulatory authorities in other regions, you can consult your local government.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Privacy'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
body {
  font-family: 'PingFang SC', 'Microsoft YaHei', Arial, sans-serif;
  background: #fff;
  color: #333;
  margin: 0;
  padding: 0;
  font-size: 15px;
  line-height: 1.6;
}
.container {
  max-width: 100%;
  width: 94%;
  margin: 0 auto;
  padding: 16px 0 24px 0;
}
h3 {
  text-align: center;
  margin: 16px 0 24px 0;
  font-weight: bold;
  font-size: 1.3em;
  color: #333;
}
h4 {
  text-align: left;
  margin: 20px 0 12px 0;
  font-weight: bold;
  font-size: 1.1em;
  color: #333;
}
.date-info {
  text-align: right;
  font-size: 14px;
  color: #666;
  margin: 8px 0 16px 0;
}
p {
  text-align: left;
  text-indent: 0;
  margin: 12px 0;
  color: #333;
}
ul.title4 {
  padding-left: 0;
  margin: 12px 0;
}
ul.title4 li {
  list-style: none;
  text-align: left;
  text-indent: 0;
  margin: 8px 0;
  color: #333;
}
a {
  color: #1890ff;
  text-decoration: none;
  word-break: break-all;
}
a:hover,
a:active {
  color: #0050b3;
  text-decoration: underline;
}
.contact {
  text-align: left;
  text-indent: 0;
  margin: 12px 0;
  color: #333;
}
.section-title {
  font-weight: bold;
  font-size: 1.05em;
  margin: 16px 0 8px 0;
  color: #333;
}
body.night {
  background: #2a3042;
  color: #fff;
}
body.night h3,
body.night h4,
body.night p,
body.night li,
body.night .contact,
body.night .section-title {
  color: #fff;
}
body.night .date-info {
  color: #ccc;
}
body.night a {
  color: #40a9ff;
}
body.night a:hover,
body.night a:active {
  color: #096dd9;
}
</style>



// WEBPACK FOOTER //
// src/components/Privacy.vue